//TO BE IMPLEMENTED SOON
import { Extension } from '@tiptap/core';
import { EventBus } from '@/eventBus/eventBus.js';

const DisableBackspace = Extension.create({
  name: 'customBackspace',

  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const { $from } = editor.state.selection;
        
        // Check if we're inside a code block - if so, allow default behavior
        const codeBlock = $from.node($from.depth).type.name === 'codeBlock';
        if (codeBlock) {
          return false; // Allow default Backspace behavior in code blocks
        }
        
        // Check if we're inside inline code - if so, allow default behavior
        const inlineCode = $from.marks().some(mark => mark.type.name === 'code');
        if (inlineCode) {
          return false; // Allow default Backspace behavior in inline code
        }
        
        const parentTest = $from.node($from.depth - 1);
        const index = $from.index($from.depth - 1);

        // Get the previous node (if it exists)
        const prevNode = index > 0 ? parentTest.child(index - 1) : null;
        const prevNodeParent = prevNode ? $from.node($from.depth - 1) : null;
        if ($from.parentOffset === 0) {
          if ($from.parent.type.name === "paragraph") {
            const parentTh = $from.node($from.depth - 1);
            if (parentTh && parentTh.type.name === "tableHeader") {
              
                const rowNode = $from.node($from.depth - 2); 
                const tableNode = $from.node($from.depth - 3); 
                const cellIndex = $from.index($from.depth - 1); 
                const rowIndex = $from.index($from.depth - 2); 
                if (tableNode && tableNode.type.name === "table" && rowIndex === 0 && cellIndex === 0) {
                  editor.commands.deleteTable();
                }
              
            }
          }
          if (prevNode != null) {
            if (prevNode.type.name == "draggableItem") {
              var parentId = prevNode.attrs["data-attributes"]["data-step-id"];
              if (parentId == null) {
                parentId = prevNode.attrs["data-attributes"]["data-temp-step-id"];
              }
              EventBus.$emit(`open_menu_enter_${parentId}`);
              return true;
            }
            else if (prevNode.type.name == "paragraph") {
              if (prevNodeParent != null && prevNodeParent.type.name == "draggableItem") {
                var prevNodeParentId = prevNodeParent.attrs["data-attributes"]["data-step-id"];
                if (prevNodeParentId == null) {
                  prevNodeParentId = prevNodeParent.attrs["data-attributes"]["data-temp-step-id"];
                }
                EventBus.$emit(`close_menu_${prevNodeParentId}`)
                return true;
              }
            }
          }
          return false;
        }

        //if (index == 0) {
        //  var behaviourOnReturn = true;
        //  //handles steps that do not have a second <p>
        //  const thirdChild = parent.childCount > 2 ? parent.child(2) : null;
        //  if (thirdChild == null) {
        //    //creates second paragraph if there isn't one in the step
        //    behaviourOnReturn = false
        //  }
        //  var parentId = parent.attrs["data-attributes"]["data-step-id"];
        //  if (parentId == null) {
        //    parentId = parent.attrs["data-attributes"]["data-temp-step-id"];
        //  }
        //  EventBus.$emit(`open_menu_enter_${parentId}`);

        //  return behaviourOnReturn;
        //}
        //else if (index == 1) {
        //  EventBus.$emit(`open_menu_enter_${parentId}`);
        //  return true;
        //}

        return false; // Prevent default behavior

      }
    }
  },
});

export default DisableBackspace;

